import { sendSyncEventToVimConnectHubApp } from '@getvim/utils-vim-connect-communication';
import { createLogger } from '../../../utils';
import { LaunchMetadata, SMARTApp, WidgetOutgoingEventName, CurrentContext } from '../../../types';
import { launchSmartAppQuery } from '../../../logic/launchSmartApp';
import { filterLogContext } from '../../../utils/filterLogContext';

const priorAuthLogger = createLogger('getSmartAppLaunchUrl');

interface SmartAppLaunchUrlParams {
  smartApp: SMARTApp;
  pubsubId: string;
  deviceId: string;
  context: CurrentContext;
}

export const getSmartAppLaunchUrl = async ({
  smartApp,
  pubsubId,
  deviceId,
  context,
}: SmartAppLaunchUrlParams): Promise<string | undefined> => {
  const { patient, selectedProvider, encounterId, searchedIcds, searchedCpts, transactionId } =
    context;
  const {
    identifiers: { ehrPatientId: patientId },
  } = patient || ({} as any);
  const logContext = filterLogContext(context);
  if (!selectedProvider || !patientId) {
    priorAuthLogger.error(`UHC ${smartApp} - missing selectedProvider/patientId`, {
      ...logContext,
      encounterId,
      transactionId,
      noPHI: true,
    });
    return undefined;
  }
  const launchEncounterId = encounterId ?? patientId;

  const launchMetadata = await launchSmartAppQuery({
    smartApp,
    pubsubId,
    deviceId,
    initialLaunchContext: {
      patientId,
      encounterId: launchEncounterId,
      selectedNpi: selectedProvider?.npi,
      transactionId,
      ...(smartApp === SMARTApp.PACS && searchedIcds?.length && { icds: searchedIcds }),
      ...(smartApp === SMARTApp.PACS && searchedCpts?.length && { cpts: searchedCpts }),
    },
  });

  return launchMetadata?.smartAppUrl ? `${launchMetadata.smartAppUrl}` : undefined;
};
